import React, { useState, useReducer } from "react";
import { useForm, Controller, useWatch } from "react-hook-form";
import { useHistory, useLocation } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import {
  Button,
  Box,
  Typography,
  useTheme,
  Container,
  Grid,
  MenuItem,
  useMediaQuery,
  withStyles,
  Select,
  FormControl,
  FormHelperText,
  TextField,
  TextareaAutosize,
  FormControlLabel,
  Checkbox,
  Modal,
  IconButton,
} from "@material-ui/core";
import { searchDataArray } from "./../components/searchDataArray";
import VerificationCode from "./VerificationCode";
import divisions from "../divisions.json";
import { useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";
// icons
import CloseIcon from "@material-ui/icons/Close";
import { useAlert } from "../components/Alert";
import LoadingModal from "../components/LoadingModal";

const SAVE_CUSTOMER = gql`
  mutation saveCustomer($customerInput: CustomerInput!) {
    saveCustomer(customerInput: $customerInput)
  }
`;

export default function BuyHousePage() {
  return (
    <>
      <Box>
        <BuyHouseContent />
      </Box>
    </>
  );
}

//ANHCOR BuyHouseContent
function BuyHouseContent() {
  const useStyles = makeStyles((theme) => ({
    backImg: {
      // height:'calc(100vh-64px)',
      width: "100%",
      objectFit: "fill",
      height: "calc(100vh - 64px )",
      display: "none",
    },
    formBox: {
      height: "100%",
      // position: "absolute",
      // top: "0",
      // bottom: "0",
      // left: "50%",
      // transform: "translateX(-50%)",
      width: "100%",
      backgroundImage: "url('/assets/images/Search/detailSearch.png')",
      backgroundSize: "cover",
    },
    root: {
      "& .MuiListItem-root.Mui-selected:hover": {},
      "& .MuiSelect-selectMenu": {
        backgroundColor: "#fff",
      },
      "& .MuiInputBase-input ": {
        backgroundColor: "#fff",
      },
      "& .Mui-focused": {
        border: "none" + " !important",
        outline: "none" + " !important",
      },
    },
  }));
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Box position="relative">
        {/* <Box width="100%">
          <img
            src="/assets/images/Search/detailSearch.png"
            className={classes.backImg}
          />
        </Box> */}
        <Box className={classes.formBox}>
          <SearchForm />
        </Box>
      </Box>
    </div>
  );
}

function SearchForm() {
  const isTable = useMediaQuery("(max-width:960px)");
  const isPhone = useMediaQuery("(max-width:600px)");
  const useStyles = makeStyles((theme) => ({
    root: {
      "& .MuiListItem-root.Mui-selected:hover": {},
      "& .MuiSelect-selectMenu": {
        backgroundColor: "#fff",
      },
      "& .Mui-focused": {
        border: "none" + " !important",
        outline: "none" + " !important",
      },
    },
    formGrid: {
      minHeight: "calc(100vh - 64px )",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-around",
      "& .MuiFormLabel-root": {
        // fontSize:'14px'+ ' !important',
      },
    },
    select: {
      position: "relative",
    },
    helperText: {
      position: "absolute",
      bottom: 0,
      transform: "translateY(100%)",
    },
  }));

  const classes = useStyles();
  const theme = useTheme();
  const history = useHistory();
  const Alert = useAlert();
  const {
    handleSubmit,
    control,
    getValues,
    setValue,
    register,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      fullName: "",
      lineId: "",
      mobile: "",
      district: "",
      subdistrict: "",
      budgetFrom: "",
      budgetTo: "",
      notice: "",
      vcode: "",
      remark: "",
    },
  });
  const { BuyTypeLand } = searchDataArray();
  const district = useWatch({ control, name: "district" });
  const divisionList = Object.keys(divisions);
  const subdistrictList = district
    ? Object.keys(divisions[district]["subdivisions"])
    : [];
  const [property, setProperty] = useState([]);

  const propertyChange = (event) => {
    const value = event.target.value;
    if (value[value.length - 1] === "全選") {
      setProperty(property.length === BuyTypeLand.length ? [] : BuyTypeLand);
      return;
    }
    setProperty(value);
  };
  const [saveCustomer, { loading: saveCustomerLoading }] = useMutation(
    SAVE_CUSTOMER,
    {
      onCompleted({ saveCustomer }) {
        if (saveCustomer) {
          window.location.reload();
          return Alert.notice("送出成功");
        }
      },
      onError(error) {
        return Alert.notice(`${error}`);
      },
    }
  );
  function _submit(data) {
    const customerInput = {
      customerType: "SERVICE_AREA",
      source: "NETWORK",
      assignStatus: "WAITING_TO_CONTACT",
      remark: `我要買房=>縣市：${divisions[data.district]["zhTW"]}，地區：${
        divisions[data.district]["subdivisions"][data.subdistrict]["zhTW"]
      }，需求類型：${property.join(",")}，買屋預算：${data.budgetFrom}～${
        data.budgetTo
      }萬${data.remark !== "" ? "，備註：" + data.remark : ""}`,
      customerInfo: [
        {
          fullName: data.fullName,
          mobile1: data.mobile,
          line: data.lineId,
        },
      ],
      frontSite: true,
    };

    saveCustomer({ variables: { customerInput } });
  }
  return (
    <Container maxWidth="lg" style={{ height: "100%" }}>
      <LoadingModal loading={saveCustomerLoading} />
      <Box className={classes.formGrid}>
        {/* form area */}
        <Grid container>
          {/* title */}
          <Grid xs={12} item>
            <Box color="#fff">
              <Typography variant={isTable ? "h4" : "h2"} align="center">
                我要買房
              </Typography>
            </Box>
          </Grid>
          {/* title area end */}
          {/* form */}
          <Grid
            container
            xs={12}
            justify={isPhone ? "space-between" : "flex-start"}
            spacing={isTable ? "2" : "4"}
          >
            {/* ANCHOR 姓名 */}
            <Grid item md={4} xs={6}>
              <Controller
                name="fullName"
                control={control}
                rules={{
                  required: "請輸入姓名",
                }}
                render={({ field, fieldState: { error } }) => (
                  <>
                    <Typography variant="body2" style={{ color: "#fff" }}>
                      姓名
                    </Typography>

                    <TextField
                      placeholder="姓名"
                      {...field}
                      error={error}
                      helperText={error && error.message}
                      fullWidth
                      size="small"
                    />
                  </>
                )}
              />
            </Grid>
            {/* ANCHOR Line 帳號 */}
            <Grid item md={4} xs={6}>
              <Controller
                name="lineId"
                control={control}
                render={({ field, fieldState: { error } }) => (
                  <>
                    <Typography variant="body2" style={{ color: "#fff" }}>
                      Line帳號
                    </Typography>
                    <TextField
                      // label="Line帳號"
                      placeholder="Line帳號"
                      {...field}
                      fullWidth
                    />
                  </>
                )}
              />
            </Grid>
            {/* ANCHOR 電話 */}
            <Grid item md={4} xs={12}>
              <Controller
                name="mobile"
                control={control}
                rules={{
                  required: "請輸入電話",
                  pattern: {
                    // value: MobilePattern,
                  },
                }}
                render={({ field, fieldState: { error } }) => (
                  <>
                    <Typography variant="body2" style={{ color: "#fff" }}>
                      電話
                    </Typography>
                    <TextField
                      placeholder="電話"
                      {...field}
                      error={error}
                      helperText={error && error.message}
                      fullWidth
                    />
                  </>
                )}
              />
            </Grid>
            {/* ANCHOR 縣市 */}
            <Grid item md={4} xs={6}>
              <Controller
                control={control}
                name="district"
                rules={{
                  required: "縣市為必填選項",
                }}
                render={({
                  field: { onChange, ...otherField },
                  fieldState: { error },
                }) => (
                  <FormControl
                    size="small"
                    variant="outlined"
                    fullWidth
                    error={error}
                  >
                    <Typography variant="body2" style={{ color: "#fff" }}>
                      縣市
                    </Typography>
                    <Select
                      {...otherField}
                      onChange={(e) => {
                        setValue("subdistrict", "");
                        onChange(e);
                      }}
                      className={classes.select}
                    >
                      {divisionList.map((item) => (
                        <MenuItem value={item}>
                          {divisions[item]["zhTW"]}
                        </MenuItem>
                      ))}
                    </Select>
                    <FormHelperText className={classes.helperText}>
                      {error && error.message}
                    </FormHelperText>
                  </FormControl>
                )}
              />
            </Grid>
            {/* ANCHOR 鄉鎮 */}
            <Grid item md={4} xs={6}>
              <Controller
                control={control}
                name="subdistrict"
                rules={{
                  required: "地區為必填選項",
                }}
                render={({ field, fieldState: { error } }) => (
                  <FormControl
                    size="small"
                    variant="outlined"
                    error={error}
                    fullWidth
                  >
                    <Typography variant="body2" style={{ color: "#fff" }}>
                      地區
                    </Typography>
                    <Select
                      {...field}
                      disabled={!district}
                      className={classes.select}
                    >
                      {subdistrictList.map((item) => (
                        <MenuItem value={item}>
                          {divisions[district]["subdivisions"][item]["zhTW"]}
                        </MenuItem>
                      ))}
                    </Select>
                    <FormHelperText className={classes.helperText}>
                      {error && error.message}
                    </FormHelperText>
                  </FormControl>
                )}
              />
            </Grid>
            {/* ANCHOR 需求類型 */}
            <Grid item md={4} xs={12}>
              <FormControl size="small" variant="outlined" fullWidth>
                <Typography variant="body2" style={{ color: "#fff" }}>
                  需求類型
                </Typography>
                {/* 需求類型 */}
                <Select
                  {...register("buyTypeLand", { required: "請選擇需求類型" })}
                  multiple
                  disableUnderline
                  onChange={propertyChange}
                  displayEmpty={true}
                  value={property}
                  className={classes.select}
                  renderValue={
                    property.length === 0
                      ? () => "請選擇"
                      : (selected) => selected.join(", ")
                  }
                  MenuProps={{
                    getContentAnchorEl: null,
                    anchorOrigin: {
                      vertical: "bottom",
                      horizontal: "left",
                    },
                  }}
                >
                  <MenuItem key="全選" value="全選">
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={
                            BuyTypeLand.length > 0 &&
                            property.length === BuyTypeLand.length
                          }
                          indeterminate={
                            property.length > 0 &&
                            property.length < BuyTypeLand.length
                          }
                        />
                      }
                      label={<Typography variant="subtitle1">全選</Typography>}
                    />
                  </MenuItem>
                  {BuyTypeLand.map((item) => (
                    <MenuItem key={item} value={item}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            className={classes.checkBox}
                            checked={property.indexOf(item) > -1}
                          />
                        }
                        label={
                          <Typography variant="subtitle1">{item}</Typography>
                        }
                      />
                    </MenuItem>
                  ))}
                </Select>
                {property.length === 0 && (
                  <FormHelperText
                    style={{ color: "red" }}
                    className={classes.helperText}
                  >
                    {errors?.buyTypeLand?.message}
                  </FormHelperText>
                )}
              </FormControl>
            </Grid>

            {/* ANCHOR 買屋預算 from */}
            <Grid item md={3} xs={6}>
              <Controller
                name="budgetFrom"
                control={control}
                rules={{
                  required: "請輸入預算範圍",
                  pattern: {
                    // value: MobilePattern,
                  },
                }}
                render={({ field, fieldState: { error } }) => (
                  <>
                    <Typography variant="body2" style={{ color: "#fff" }}>
                      買屋預算
                    </Typography>
                    <Box display="flex" alignItems="center">
                      <TextField
                        placeholder={isPhone ? "預算範圍" : "請輸入買屋預算"}
                        {...field}
                        error={error}
                        helperText={error && error.message}
                        fullWidth
                      />
                      <Typography
                        style={{
                          color: "#fff",
                          transform: isPhone
                            ? "translateX(8px)"
                            : "translateX(16px)",
                        }}
                      >
                        一
                      </Typography>
                    </Box>
                  </>
                )}
              />
            </Grid>

            {/* ANCHOR  買屋預算  to */}

            <Grid item md={3} xs={6}>
              <Controller
                name="budgetTo"
                control={control}
                rules={{
                  required: "請輸入預算範圍",
                  pattern: {
                    // value: MobilePattern,
                  },
                }}
                render={({ field, fieldState: { error } }) => (
                  <>
                    <Typography
                      variant="body2"
                      style={{ color: "#fff", opacity: "0" }}
                    >
                      買屋預算
                    </Typography>
                    <Box display="flex" alignItems="center">
                      <TextField
                        placeholder={isPhone ? "預算範圍" : "請輸入買屋預算"}
                        {...field}
                        error={error}
                        helperText={error && error.message}
                        fullWidth
                      />
                      <Typography
                        variant={isPhone ? "" : "body2"}
                        style={{
                          color: "#fff",
                          paddingLeft: isPhone ? "" : "5px",
                        }}
                      >
                        萬
                      </Typography>
                    </Box>
                  </>
                )}
              />
            </Grid>
            {/* ANCHOR 房貸試算工具 */}
            <Grid item md={3} xs={12} style={{ alignSelf: "flex-end" }}>
              <Button
                variant="contained"
                color="primary"
                size="large"
                style={{ borderRadius: "30px" }}
                onClick={() => history.push("./interest-calculation")}
              >
                <Typography style={{ color: "#fff" }}>房貸試算工具</Typography>
              </Button>
            </Grid>
            {/* ANCHOR 備註 */}
            <Grid item xs={12}>
              <Controller
                name="remark"
                control={control}
                render={({ field, fieldState: { error } }) => (
                  <TextareaAutosize
                    {...field}
                    name="message"
                    placeholder="備註"
                    style={{
                      height: "120px",
                      width: "100%",
                      resize: "none",
                      fontSize: "1em",
                      padding: "10px",
                    }}
                  />
                )}
              />
            </Grid>
          </Grid>

          {/* ANCHOR Notice   */}
          <Grid container item xs={12} alignItems="center">
            <Grid item>
              <Controller
                name="notice"
                control={control}
                rules={{ required: "請閱讀注意事項" }}
                render={({ field, fieldState: { error } }) => (
                  <Grid container item>
                    <Grid item xs={12} container alignItems="center">
                      <Checkbox
                        {...field}
                        style={{
                          color: "#E1B663",
                        }}
                        checked={field.value}
                        onChange={(e) => field.onChange(e.target.checked)}
                      />
                      <Typography style={{ color: "#fff" }}>
                        我已經閱讀完&nbsp;
                      </Typography>
                      <NoticeModal control={control} />
                    </Grid>
                    <Grid item xs={12}>
                      <Typography
                        variant="body2"
                        style={{ color: "#f44336", paddingLeft: "2.3em" }}
                      >
                        &nbsp;&nbsp;
                        {error?.message}
                        &nbsp;&nbsp;
                      </Typography>
                    </Grid>
                  </Grid>
                )}
              />
            </Grid>
            <Grid item md={5} xs={3}>
              <Controller
                name="vcode"
                control={control}
                rules={{
                  validate: (v) => {
                    if (v !== localStorage.getItem("@fullhouseVcode"))
                      return "驗證碼錯誤";
                  },
                }}
                render={({ field, fieldState: { error } }) => (
                  <>
                    <Typography variant="body2" style={{ color: "#fff" }}>
                      驗證碼
                    </Typography>
                    <Grid container item spacing={1} direction="row">
                      <Grid item>
                        <TextField
                          {...field}
                          error={error}
                          helperText={error && error.message}
                          fullWidth
                          size="small"
                        />
                      </Grid>
                      <Grid item>
                        <VerificationCode />
                      </Grid>
                    </Grid>
                  </>
                )}
              />
            </Grid>
          </Grid>

          {/* form area end */}
        </Grid>
        {/* button */}
        <Box display="flex" justifyContent="center">
          <Button
            variant="contained"
            onClick={handleSubmit(_submit)}
            fullWidth
            style={{
              color: "#fff",
              backgroundColor: theme.palette.secondary.light,
              borderRadius: "40px",
              height: "50px",
              width: isTable ? "30%" : "30%",
              marginTop: "40px",
            }}
          >
            送出
          </Button>
        </Box>
      </Box>
    </Container>
  );
}

// notice popup

function NoticeModal() {
  const theme = useTheme();
  const isPhone = useMediaQuery("(max-width:600px)");
  const useStyles = makeStyles((theme) => ({
    modalPaper: {
      position: "absolute",
      left: "50%",
      top: "50%",
      transform: "translate(-50%,-50%)",
      maxWidth: 800,
      minWidth: isPhone ? 300 : 400,
      backgroundColor: theme.palette.background.paper,
      border: "2px solid #000",
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
    },
    closeIcon: {
      position: "absolute",
      top: "0",
      right: "0",
    },
  }));
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div style={{ display: "inline-block" }}>
      <Typography
        variant="subtitle1"
        style={{ color: theme.palette.secondary.light, cursor: "pointer" }}
        onClick={handleOpen}
        component="span"
      >
        <b>投標注意事項</b>
      </Typography>
      <Modal open={open} onClose={handleClose}>
        <div className={classes.modalPaper}>
          <IconButton
            className={classes.closeIcon}
            onClick={() => setOpen(false)}
          >
            <CloseIcon />
          </IconButton>
          {/* 注意條款 */}
          <p>注意事項</p>
        </div>
      </Modal>
    </div>
  );
}
